import { Box, Grid, Paper, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  Legend as BarLegend,
  ResponsiveContainer as BarResponsiveContainer,
  Tooltip as BarTooltip,
  CartesianGrid,
  Cell,
  Legend,
  Line,
  LineChart,
  Legend as LineLegend,
  ResponsiveContainer as LineResponsiveContainer,
  Tooltip as LineTooltip,
  XAxis as LineXAxis,
  YAxis as LineYAxis,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useSuperAdminSingleSuscrip } from "../../../../context/SuperAdmin/SingleSuscriptContext";

interface Props {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  growthData: any[];
}

const CreditsGraphs: FC<Props> = ({ setIsLoading, growthData }) => {
  const { suscribedUsers, plan, suscripcion } = useSuperAdminSingleSuscrip();

  const [lineData, setLineData] = useState<any[]>([]);

  useEffect(() => {
    if (growthData.length > 0) {
      setLineData(
        growthData.map((item) => ({
          name: item.name,
          value: item.creditosGastados,
        }))
      );
      setIsLoading(false);
    }
  }, [growthData]);

  const COLORS = ["#0088FE", "#00C49F", "#FF8042"];

  const totalAsignados = suscribedUsers.length * plan.total_creditos;
  const totalSinAsignar =
    plan.total_creditos * plan.max_usuarios - totalAsignados;
  const totalGastados = suscripcion.creditos_gastados;

  const pieData = [
    { name: "Créditos Asignados", value: totalAsignados },
    { name: "Créditos Sin Asignar", value: totalSinAsignar },
    { name: "Créditos Gastados", value: totalGastados },
  ];

  const barData = [
    {
      name: "Plan",
      Asignados: totalAsignados,
      SinAsignar: totalSinAsignar,
      Gastados: totalGastados,
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Paper sx={{ padding: 2 }}>
          <Typography variant="h6" gutterBottom>
            Total de suscripciones
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "35vh",
            }}
          >
            <Typography variant="h1" gutterBottom>
              {suscribedUsers.length}
            </Typography>
          </Box>
        </Paper>
      </Grid>
      <Grid item xs={6}>
        <Paper sx={{ padding: 2 }}>
          <Typography variant="h6" gutterBottom>
            Distribución de Créditos
          </Typography>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={pieData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={80}
                fill="#8884d8"
                label
              >
                {pieData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </Paper>
      </Grid>

      <Grid item xs={6}>
        <Paper sx={{ padding: 2 }}>
          <Typography variant="h6" gutterBottom>
            Créditos Asignados vs. No Asignados
          </Typography>
          <BarResponsiveContainer width="100%" height={300}>
            <BarChart data={barData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <BarTooltip />
              <BarLegend />
              <Bar dataKey="Asignados" fill="#8884d8" />
              <Bar dataKey="SinAsignar" fill="#00C49F" />
              <Bar dataKey="Gastados" fill="#FF8042" />
            </BarChart>
          </BarResponsiveContainer>
        </Paper>
      </Grid>

      <Grid item xs={6}>
        <Paper sx={{ padding: 2 }}>
          <Typography variant="h6" gutterBottom>
            Crecimiento Consumo de Créditos
          </Typography>
          <LineResponsiveContainer width="100%" height={300}>
            <LineChart data={lineData}>
              <CartesianGrid strokeDasharray="3 3" />
              <LineXAxis dataKey="name" />
              <LineYAxis />
              <LineTooltip />
              <LineLegend />
              <Line type="monotone" dataKey="value" stroke="#8884d8" />
            </LineChart>
          </LineResponsiveContainer>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default CreditsGraphs;
